import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterContentInit, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, Input, OnChanges, OnInit, SecurityContext, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgModel, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTab, MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { DomSanitizer, SafeResourceUrl, SafeStyle } from '@angular/platform-browser';
import * as moment from 'moment';
import { interval } from 'rxjs';
import { SettingsService, TimePickerComponent, T4RentalService, T4File, PickupResultCode, ReturnResultCode, SystemRights, AuthService, ContextInfo, ReceiptType } from 't4core';
import { BookingErrorCode, BookingValidation, Country, CustomerInfo, CustomerType, DiscountModel, DiscountReasonInfo, LocationInfo, ObjectTypeInfo, OpenHours, PaymentInfo, PriceInfoModel, PriceModel, RentalInfo, RentalObjectInfo, RentalStatus, ReturnResultAction, ReturnValidation, ReturnValidationResult, SparepartPriceModel, SafetyCheckQuestionInfo, RentalMetaData } from 't4core';
import { DialogBase } from 't4core';
import { T4DatatableWidget } from '../../components/datatable/datatable';
import { CallDialog } from '../CallDialog/CallDialog';
import { CreateServiceRequestDialog } from '../createServiceRequestDialog/createServiceRequestDialog';
import { FindLocationDialog } from '../FindLocationDialog/FindLocationDialog';
import { NearbyOneWayAvailabilityDialog } from '../NearbyOneWayAvailabilityDialog/NearbyOneWayAvailabilityDialog';
import { ReturnDialog } from '../returnDialog/returnDialog';
import { SmsCodeDialog } from '../Signing/SmsCodeDialog/SmsCodeDialog';
import { SmsDialog } from '../SmsDialog/SmsDialog';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { ImageDialog } from '../ImageDialog/ImageDialog';
import { delay } from 'rxjs/operators';
import { ClientSettings, DisableObjectResult, DiscountValueType, PaymentRequestInfo } from '../../../../projects/t4core/src/public-api';
import { RentalCustomerDetails } from '../../components/RentalCustomerDetails/RentalCustomerDetails';
import { CustomerDialog } from '../CustomerDialog/CustomerDialog';
import { clear } from 'console';
interface FormValidation {
    FieldId: string;
    Visible: boolean;
    DefaultValue: string;
    Required: boolean;
    Minlength: number;
    RegEx: string;
    CopyFrom: string;
    Placeholder: string;
}

export class SecurityCheckPoint {
    public Key: string;
    public Name: string;
    public requireComment: Boolean;
    constructor(data: { Key: string, Name: string, requireComment?: Boolean }) { this.Key = data.Key; this.Name = data.Name; this.requireComment = data.requireComment; }

    private _ok: boolean;
    public get Ok(): boolean { return this._ok; }
    public set Ok(val: boolean) {
        this._ok = val;
        if (this._ok) this.Failed = false;
    }

    private _failed: boolean;
    public get Failed(): boolean { return this._failed; }
    public set Failed(val: boolean) {
        this._failed = val;
      if (this._failed) this.Ok = false;
    }
}

export class SecurityCheckModel {
    public CheckPoints: SecurityCheckPoint[] = [];
    public Remarks: string = "";
    constructor(checkPointsData: any[] = []) {
    // Map the API response to the SecurityCheckPoint class
    this.CheckPoints = checkPointsData.map(cp => new SecurityCheckPoint(cp));
  }

  public get IsValid(): boolean {
    return this.CheckPoints.some(x => !x.Ok && !x.Failed);
    }

    public get HasDeviation(): boolean {
        return this.CheckPoints.some(x => x.Failed);
    }
}

@Component({
    animations: [
        trigger('returnDialog', [
            // ...
            state('open', style({
                opacity: 1,
                display: 'block'
            })),
            state('closed', style({
                opacity: 0,
                display: 'none'
            })),
            transition('open => closed', [
                animate('0.5s')
            ]),
            transition('closed => open', [
                animate('0.5s')
            ]),
        ]),
    ],
    selector: 'dialog-rentaldialog',
    templateUrl: './rentaldialog.html',
    styleUrls: ['./rentalDialog.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RentalDialog extends DialogBase implements OnInit, OnChanges {
    // Elements
    @ViewChild("tabs", {static: false}) public tabReceipt: MatTabGroup;

    // Form
    @ViewChild("frmCustomerInfo", { static: false }) public frmCustomerInfo: RentalCustomerDetails;

    @ViewChild("txtPickupDate", {static: false})     public txtPickupDate: NgModel;
    @ViewChild("txtPickupTime", {static: false})     public txtPickupTime: TimePickerComponent;

    @ViewChild("txtReturnDate", {static: false})     public txtReturnDate: NgModel;
    @ViewChild("txtReturnTime", {static: false})     public txtReturnTime: TimePickerComponent;

    @ViewChild("chkInsurance", {static: false})      public chkInsurance: MatCheckbox;
    @ViewChild("txtComments", {static: false}) public txtNotes: NgModel;

    @ViewChild("txtActualReturnDate", {static: false}) public txtActualReturnDate: NgModel;
    @ViewChild("txtActualReturnTime", {static: false}) public txtActualReturnTime: TimePickerComponent;

    @ViewChild("tabHistory", { static: false }) public tabHistory: MatTab;
    @ViewChild("tabSecurityCheck", { static: false }) public tabSecurityCheck: MatTab;

    @ViewChild("tblPayments", { static: false }) private tblPayments: T4DatatableWidget;
    @ViewChild("tblCosts", { static: false }) private tblCosts: T4DatatableWidget;
    @ViewChild("tblPaymentRequests", { static: false }) private tblPaymentRequests: T4DatatableWidget;

    @Input() bookingInput = 0; 

    public startFromNow: boolean = false;

    // <ViewModel>
    private _isInitializing: boolean = true;
    public booking: RentalInfo = new RentalInfo();
    public currentPrice: PriceModel = new PriceModel();
    public pricingIntervals: number[] = [];
  public extraReceiptExists: boolean = false;
  public iglooLock: any;

    public discountReasons: DiscountReasonInfo[] = [];
    public currentDiscount: DiscountModel;
    public get currentDiscountReason(): string {
        if (!this.currentDiscount) return "";

        var i = this.discountReasons.find(x => x.Id == this.currentDiscount.ReasonId);
        if (!i) return "";

      return i.Reason;
    }

    // Customer
    public overrideCustomerBlock: boolean = false;

    public discount = {
        value: 100,
        type: '%',
        reason: '',
        comment: '',
        code: ''
    }
    /// Access
    public canChangeReturnTime: boolean = true;
    public mayEdit: boolean = true;
    public confirmedOutsideOpenHours: boolean = false;

    private updateCanChangeReturnTime() {
        // Other locations may never change
        if (this.Settings.clientSettings.RentalLocationId && (this.booking.PickupLocationId != this.Settings.clientSettings.RentalLocationId && this.booking.ReturnLocationId != this.Settings.clientSettings.RentalLocationId)) {
            this.canChangeReturnTime = false;
            return;
        }

        if (this.booking.Status == RentalStatus.Returned || this.booking.Status == RentalStatus.Canceled) {
            this.canChangeReturnTime = false;
            return;
        }

        if (this.Settings.isInAny(['OneWayAdmin'], true)) {
            this.canChangeReturnTime = true;
            return;
        } 

        if (this.booking.Status < RentalStatus.Late) {
            this.canChangeReturnTime = true;
            return;
        }
        if (this.Settings.clientSettings.Bookings.AllowChangeWhenDelayed) {
            this.canChangeReturnTime = true;
            return;
        }

            this.canChangeReturnTime = false;
            return;
    }

    private updateMayEdit() {
        this.mayEdit = this.booking.Status >= this.rentalStatus.Active || !this.Settings.clientSettings.RentalLocationId || (this.booking.IsOneWay || this.booking.PickupLocationId == this.Settings.clientSettings.RentalLocationId);
    }

    private updateState() {
        this.updateMayEdit();
        this.updateCanChangeReturnTime();
      this.updateAllowCancel();
      this.updateAllowReverce();
    }

    /// Access
    private isCustomerChanged: Boolean = false;
    private isObjectChanged: Boolean = false;
    private isLocationChanged: Boolean = false;
    private isForeignTravelChanged: Boolean = false;
    private hasAddonsChanged: Boolean = false;
    private isDiscountChanged: Boolean = false;
    private isPeriodChanged: Boolean = false;

    public bookingValidation: BookingValidation;
    public _openHoursCache: OpenHours[] = [];
    public availableAddons: ObjectTypeInfo[] = [];

    public contextName: string;

    public localLoaders = {
        customer: false,
        price: false,
        return: false,
        period: false,
        objects: false,
        addableTypes: false,
        discount: false,
        receipt: false
    };

    public loadStatus = {
        objects: false
    }

   public damageCostAdded: boolean = false;

    public rentalStatus = RentalStatus;
    public bookingErrorCode = BookingErrorCode;
    public customerType = CustomerType;

    public clientSettingsForm: ClientSettings;
    public pickupDate: Date = new Date();
    public setPickupDate(val: MatDatepickerInputEvent<Date>) {
        if (!this.booking || !this.booking.PickupTime) return;

        var currentDiff = moment(this.booking.ReturnTime).diff(moment(this.booking.PickupTime), 'minutes');

        var v = moment(val.value);
        var newDate = this.booking.PickupTime.clone();
        newDate.year(v.year());
        newDate.month(v.month());
        newDate.date(v.date());

        this.booking.PickupTime = newDate;
        this.pickupDate = newDate.toDate();

        if (this.booking.PickupTime >= this.booking.ReturnTime) {
            this.setReturnDate(this.booking.PickupTime.clone().add(currentDiff, 'minute').toDate());
        }

        if (!this._isInitializing) this.updateOpenHours();
        if (!this._isInitializing) this.updatePrice();
        if (!this._isInitializing) this.validateBooking();
    }
    public setPickupTime(val: moment.Moment) {
        if (!this.booking || !this.booking.PickupTime) return;
        if (val.isSame(this.booking.PickupTime)) return;

        this.booking.PickupTime.hours(val.hour());
        this.booking.PickupTime.minutes(val.minute());
        this.booking.PickupTime.seconds(0);

        if (!this._isInitializing) this.updatePrice();
        if (!this._isInitializing) this.validateBooking();
    }

    public returnDate: Date = new Date();
public setReturnDate(val: Date) {
  if (!this.booking || !this.booking.ReturnTime || !this.booking.PickupTime) return;

  const picked = moment(val);

  const newReturn = this.booking.ReturnTime.clone()
    .year(picked.year())
    .month(picked.month())
    .date(picked.date());

  // Enforce minimum length if return is not after pickup.
  if (this.booking.PickupTime.isSameOrAfter(newReturn)) {
    this.booking.ReturnTime = this.booking.PickupTime.clone().add(this.Settings.clientSettings.Bookings.DefaultBookingLength, 'hours');
  } else {
    this.booking.ReturnTime = newReturn;
  }

  this.returnDate = this.booking.ReturnTime.toDate();

  if (!this._isInitializing) {
    this.updateOpenHours();
    this.updatePrice();
    this.validateBooking();
  }
}

    public setReturnTime(val: moment.Moment) {
        if (!this.booking || !this.booking.ReturnTime) return;

        this.booking.ReturnTime.hours(val.hour());
        this.booking.ReturnTime.minutes(val.minute());
        this.booking.ReturnTime.seconds(0);

        if (!this._isInitializing) this.updatePrice();
        if (!this._isInitializing) this.validateBooking();
    }
    public setRentalLength(hours: number) {
        var t = this.booking.PickupTime.clone().add(hours, 'hours');
        this.setReturnDate(t.toDate());
        this.setReturnTime(t);
        this.isPeriodChanged = true;
    }
    public extendRentalLength(hours: number) {
        var t = this.booking.ReturnTime.clone().add(hours, 'hours');
        this.setReturnDate(t.toDate());
        this.setReturnTime(t);
        this.isPeriodChanged = true;
    }


    public actualReturnDate: Date = new Date();
    public setActualReturnDate(val: Date) {
        var v = moment(val);
        this.returnTime.year(v.year());
        this.returnTime.month(v.month());
        this.returnTime.date(v.date());

        this.actualReturnDate = this.returnTime.toDate();

        this.checkBookingForReturn();

    }
    public setActualReturnTime(val: moment.Moment) {
        this.returnTime.hours(val.hour());
        this.returnTime.minutes(val.minute());
        this.returnTime.seconds(0);

        this.checkBookingForReturn();
    }

    public locations: LocationInfo[] = [];
    public pickupLocations: LocationInfo[];
    public returnLocations: LocationInfo[];

    public pickupOpens: moment.Moment = moment().startOf('day').add(6, 'hour');
    public pickupCloses: moment.Moment = moment().startOf('day').add(20, 'hour');
    public returnOpens: moment.Moment = moment().startOf('day').add(6, 'hour');
    public returnCloses: moment.Moment = moment().startOf('day').add(20, 'hour');

    public availableCategories: string[] = [];
    public availableObjects: any = {};
    public availableTypes: ObjectTypeInfo[] = [];
    public selectedType: ObjectTypeInfo;

    // States
    public isReturnState: boolean = false;

    // Return
    public returnTimeType: string = "Now";
    public returnTime: moment.Moment = this.round(moment(), 15, 'minute');
    public returnValidation: ReturnValidation;

    public returnActionRequired(): Boolean {
        if (!this.returnValidation) return false;

        if (this.returnValidation.Action == ReturnResultAction.Unspecified) {
            if (this.returnValidation.Result == ReturnValidationResult.Changed) return true;
            if (this.returnValidation.Result == ReturnValidationResult.Late) return true;
            if (this.returnValidation.Result == ReturnValidationResult.WrongLocation) return true;
        }

        return false;
    }

    // Foreign travel
    @ViewChild("txtCountry", {static: false}) public txtCountry: ElementRef;
    private countries: Country[] = [];
    public filteredCountries: Country[] = [];
    public selectedCountry: Country;

    public chkForeignChange(chkForeign: any) {
        this.isForeignTravelChanged = true;

        if (chkForeign.checked) {
            if (!this.booking.ForeignCountry)
                this.selectCountry(this.filteredCountries[Math.floor(Math.random() * this.filteredCountries.length)]);
            else
                this.selectCountry(this.filteredCountries.find(x => x.Code == this.booking.ForeignCountry));

          this.addAddon(this.availableAddons.find(x => x.Id == 843));

            setTimeout(() => this.txtCountry.nativeElement.focus(), 100);
        } else {
            this.booking.OutlandCode = "";
            this.booking.ForeignCountry = "";
            this.removeAddon(this.availableAddons.find(x => x.Id == 843));
        }

        this.isForeignTravelChanged = true;
    }

    public filterCountries(key: string) {
        var ret = this.countries.filter(x => x.Name.toLowerCase().indexOf(key.toLowerCase()) >= 0);
        this.filteredCountries = ret;
    }

    public changeCountry(event: MatAutocompleteSelectedEvent) {
        this.selectCountry(event.option.value);
        this.isForeignTravelChanged = true;
    }

    public selectCountry(c: Country) {
        this.selectedCountry = c;

        if (!this.booking.OutlandCode) {
            var code = "";
            for (var i = 0; i < 4; i++) code += Math.floor(Math.random() * 10);
            code += "-";
            for (var i = 0; i < 4; i++) code += Math.floor(Math.random() * 10);

            this.booking.OutlandCode = code;
        }
        this.booking.ForeignCountry = c.Code
        this.countryMapUri = this.sanitizer.bypassSecurityTrustStyle("url(https://maps.googleapis.com/maps/api/staticmap?center=" + this.selectedCountry.Lat + "," + this.selectedCountry.Lng + "&zoom=3&size=450x328&maptype=roadmap&markers=" + this.selectedCountry.Lat + "," + this.selectedCountry.Lng + "&key=AIzaSyAPITA4UuI9ERN_XiTDXZC1packZFkx-xE)");
    }

    public countryDisplayName(c: Country): string {
        return c.Name;
    }

    public allowCancel: boolean = true;
  private updateAllowCancel(): boolean {
    if (this.booking.Status == RentalStatus.Canceled) return false;

      if (this.Settings.isInAny(["OneWayAdmin"])) return true;
        if (this.booking.Status == RentalStatus.Reserved) return true;
        if (this.booking.Status == RentalStatus.ReservedAndBound) return true;
      if (this.booking.Status == RentalStatus.Active && this.booking.ActivatedAt.clone().add(15, 'minutes') > this.now) return true; // Allow within 15m of disclose

        return false;
  }

  public allowReverse: boolean = true;

  private updateAllowReverce(): boolean{
    if (this.Settings.isInAny(["OneWayAdmin"]) && this.booking.Status >= RentalStatus.Active)
      return true;

    return false;
}


    // </ViewModel>

    public receiptUri: SafeResourceUrl;
    public extraReceiptUri: SafeResourceUrl;
    public countryMapUri: SafeStyle;

    //Form settings and validation
    //public customerForm: FormGroup;
    //public customerForm2: FormGroup;
    //public formSettings: FormValidation[] = [];
    //public errorMessages: [string, string][] = [];

    //public placeholders: [string, string][] = [];

    //public showSSN: boolean = true;
    //public showFirstName: boolean = true;
    //public showLastName: boolean = true;
    //public showAddress: boolean = true;
    //public showZip: boolean = true;
    //public showCity: boolean = true;
    //public showPhone: boolean = true;
    //public showEmail: boolean = true;

    //Rental photos
    public pickupRentalPhotos: any[] = [];
    public returnRentalPhotos: any[] = [];

    //Security checks
    public pickupSecurityCheck: SecurityCheckModel;
    public returnSecurityCheck: SecurityCheckModel;

    constructor(
      public dialogRef: MatDialogRef<RentalDialog>,
      @Inject(MAT_DIALOG_DATA) public params: any,
        private sanitizer: DomSanitizer,
      private _cdr: ChangeDetectorRef,
        private rentalSvc: T4RentalService,
      private fb: FormBuilder,
        private authSvc: AuthService
  ) {
        super("RentalDialog");

      this.booking.Customer = new CustomerInfo();

      // Cancel booking context when closed
      this.dialogRef.afterClosed().subscribe(x => {
        this.authSvc.dismissRental();
      });

        interval(500).subscribe(x => {
            this._cdr.markForCheck();
        });
    }

  private async LoadBooking(bookingId: number) {

    this.clientSettingsForm = await this.Api.get<ClientSettings>("/Settings/GetCustomerDefinition", { rentalId: bookingId })
    
    this.booking = await this.Api.get<RentalInfo>("/Rental/GetRentalInfo", { bookingId: bookingId });

    this.pickupDate = this.booking.PickupTime.toDate();
    this.returnDate = this.booking.ReturnTime.toDate();
    this.selectedType = this.booking.PrimaryType;
    
    if (this.booking?.RentalObject?.Locks?.find(x => x.DeviceType == 0 && x.Password != null) != null) {
      this.iglooLock = this.booking.RentalObject.Locks.find(x => x.DeviceType === 0 && x.Password != null);
    }

    this.receiptUri = this.sanitizer.bypassSecurityTrustResourceUrl(await this.rentalSvc.GetReceiptUri(this.booking.Id, "Pickup"));
    this.extraReceiptUri = this.sanitizer.bypassSecurityTrustResourceUrl(await this.rentalSvc.GetReceiptUri(this.booking.Id, "Return"));

    this.updateOpenHours();
    this.updateAddableProducts();
    this.validateBooking();
    this.updatePricingIntervals();

    //Set all form values from customer
    /*this.frmCustomerInfo.setFormValue();*/
  }

    async ngOnInit() {

      if (this.bookingInput == 0) {

        /*await this.createForm(this.params.booking == undefined);*/

      var token = this.beginLoad("Turbo.Core.Dialogs.RentalDialog.ldrRental", "Preparing booking...", null);
      if (this.params.booking) {
        // Make sure all requests uses the context from the booking
       /*if (this.Settings.isInAny(['OneWayAdmin', 'Admin', 'GroupManager']))*/
          await this.authSvc.actOnRental(this.params.booking);

          await this.LoadBooking(this.params.booking);

          if (this.booking.IsOneWay) await this.loadLocations();
          setTimeout(x => this._isInitializing = false, 100);
          this.endLoad(token);
        }
      else {
        if (this.params.context) {
          this.clientSettingsForm = await this.Api.get<ClientSettings>("Settings/GetCustomerDefinitionGuid", { bookingContext: this.params.context });
        }
        else if (this.params.isOneWay) {
          this.clientSettingsForm = await this.Api.get<ClientSettings>("Settings/GetCustomerDefinitionGuid", { bookingContext: "43D09B7E-079A-4B29-83CB-ABBC928A7358" });
        }
        else
          this.clientSettingsForm = this.Settings.clientSettings;

          var b = new RentalInfo();
          b.Status = RentalStatus.New;

          b.PickupLocationId = this.params.pickupLocationId;
          b.ReturnLocationId = this.params.returnLocationId;
          b.ObjectId = this.params.objectId;
          if (b.ObjectId) b.RentalObject = await this.Api.get<RentalObjectInfo>("/RentalObject/GetObjectInfo", { objectId: b.ObjectId });
          b.PrimaryObjectTypeId = this.params.typeId;
          if (b.PrimaryObjectTypeId) b.PrimaryType = await this.Api.get<ObjectTypeInfo>("/RentalObject/GetTypeInfo", { objectType: b.PrimaryObjectTypeId });
          b.IsOneWay = this.params.isOneWay ? true : false;

          if (!this.params.pickupTime) {
            b.PickupTime = this.round(moment(), 15, 'minute');
            var priceSettings = await this.Api.get<PriceInfoModel>("/Price/GetPriceInfo", {
              pickupTime: b.PickupTime.toISOString(),
              objectType: b.PrimaryObjectTypeId,
              webBooking: false
            });

            if (b.IsOneWay)
              b.ReturnTime = b.PickupTime.clone().add(1, 'day');
            else
              b.ReturnTime = b.PickupTime.clone().add(this.Settings.clientSettings.Bookings.DefaultBookingLength, 'hours');
          }
          else {
            b.PickupTime = moment(this.params.pickupTime);
            b.ReturnTime = moment(this.params.returnTime);

            // Check if smaller than minimum time

            //if (b.ReturnTime < b.PickupTime.clone().add(this.Settings.clientSettings.Bookings.DefaultBookingLength, 'hours')) {
            //  b.ReturnTime = b.PickupTime.clone().add(this.Settings.clientSettings.Bookings.DefaultBookingLength, 'hours');
            //}
          }

          this.booking = b;
          this.pickupDate = b.PickupTime.toDate();
          this.returnDate = b.ReturnTime.toDate();
          this.selectedType = this.booking.PrimaryType;

          this.booking.CreatedAt = moment();
          this.booking.IsWebRental = false;

          this.booking.Customer = new CustomerInfo();
          this.booking.Customer.Type = CustomerType.Consumer;

          this.updateOpenHours();
          this.updateAddableProducts();
          this.validateBooking();
          this.updatePricingIntervals();

          if (this.booking.IsOneWay) {
            await this.loadLocations();
            if (!this.booking.PickupLocation && b.PickupLocationId) this.booking.PickupLocation = this.locations.find(x => x.Id == b.PickupLocationId);
            if (!this.booking.ReturnLocation && b.ReturnLocationId) this.booking.ReturnLocation = this.locations.find(x => x.Id == b.ReturnLocationId);
          }

         setTimeout(x => this._isInitializing = false, 100);
         this.endLoad(token);
        }


        if (this.booking.IsOneWay && this.booking.PickupLocationId)
          this.availableTypes = await this.Api.get<ObjectTypeInfo[]>("/RentalObject/GetTypesAtLocation", { location: this.booking.PickupLocationId, oneway: true })

        if (this.params.tabIndex && this.params.tabIndex > 0) {
          this.tabReceipt.selectedIndex = this.params.tabIndex;
          this.loadObjectTab();
        }

        this.updateState();

      }

      var minutsFromNow = moment(this.now).diff(moment(this.booking.PickupTime), 'minute') * -1;

      if (minutsFromNow <= (2*60)) {
        this.startFromNow = true;
      }
      if (this.Settings.isInAny(['Admin'], true)) {
        var traceInfo = await this.Api.get<ContextInfo>("/Util/TraceByRental", { rentalId: this.booking.Id });
        if (traceInfo)
          this.contextName = traceInfo.Name;
      }
      

        var token = this.beginLoad("Turbo.Core.Dialogs.RentalDialog.ldrRental", "Preparing booking...", null);
      this.endLoad(token);
    }

    public async getSecurityChecks(): Promise<SecurityCheckModel> {
        if (this.booking.Id && this.booking.RentalObject && this.booking.RentalObject.Id) {
            var token = this.UI.beginLoading("Intellitrailer.RentalService.ReturningObject", "Getting security check", null);

            for (let i = 0; i < 2; i++) {
                var data = await this.Api.get<string>("/RentalObject/GetSecurityCheck",
                    {
                        rentalObjectId: this.booking.RentalObject.Id,
                        rentalId: this.booking.Id,
                        isReturn: i < 1 ? false : true
                    });

              if (data) {
                  //Safety Check Question Info
                  var res = await this.Api.get<SafetyCheckQuestionInfo[]>("Rental/GetSafetyCheckQuestionsForType", { typeClassId: this.booking.RentalObject.Type.TypeClassId });
                  var securityCheck = new SecurityCheckModel(res);

                  var object = JSON.parse(data);

                    securityCheck.Remarks = object.remarks;
                    for (let checkPoint of object.securityChecks) {
                        if (securityCheck.CheckPoints.find(x => x.Key == checkPoint.key)) {
                            securityCheck.CheckPoints[securityCheck.CheckPoints.findIndex(x => x.Key == checkPoint.key)].Ok = checkPoint.ok;
                            securityCheck.CheckPoints[securityCheck.CheckPoints.findIndex(x => x.Key == checkPoint.key)].Failed = !checkPoint.ok;
                        }
                    }
                    this.UI.loaderCompleted(token);

                    if (i == 0) {
                      this.pickupSecurityCheck = securityCheck;
                      console.log("pickup security check", this.pickupSecurityCheck);

                    }
                    else if (i == 1) {
                        this.returnSecurityCheck = securityCheck;
                    }

                }
            }
        }
        this.UI.loaderCompleted(token);
        return null;
    }

    public async getRentalPhotos() {
        if (this.booking.Id && this.booking.RentalObject && this.booking.RentalObject.Locks) {
            var rentalPhotos = await this.Api.get<any[]>("RentalObject/GetRentalPhotos", { bookingId: this.booking.Id });

            this.returnRentalPhotos = [];
            this.pickupRentalPhotos = [];
            for (let photo of rentalPhotos) {
                if (photo.Filename.indexOf("Return") > -1) {
                    this.returnRentalPhotos.push(photo);
                }
                else if (photo.Filename.indexOf("Pickup") > -1) {
                    this.pickupRentalPhotos.push(photo);
                }
            }
        }
    }

    public async openImage(file: T4File) {
        if (file.Filename.endsWith('jpg') || file.Filename.endsWith('jpeg') || file.Filename.endsWith('png')) {
            var ret = await this.Dialog.open(ImageDialog, { data: { imageData: file.Uri } }).afterClosed().toPromise();
        }
        else {
            window.open(file.Uri, "_blank");
        }
    }

    public async clearDiscount() {
        var x = await this.UI.confirm("Turbo.Core.RentalDialog.headConfirmClearDiscount", "Remove discount?", "Turbo.Core.RentalDialog.errConfirmClearDiscount", "Do you wish to remove the discount from this booking?");

        if (x) {
            this.booking.DiscountId = null;
            this.isDiscountChanged = true;
            this.updatePrice();
            this.currentDiscount = null;
        }
    }

    public async validateDiscountCode() {
        try {
            this.localLoaders.discount = true;

            var ret = await this.Api.get<DiscountModel>("Price/ValidateDiscount", {
                code: this.discount.code,
                pickupTime: this.booking.PickupTime.toISOString(),
                returnTime: this.booking.ReturnTime.toISOString(),
                pickupLocationId: this.booking.PickupLocationId,
                returnLocationId: this.booking.ReturnLocationId,
                objectTypeId: this.booking.PrimaryObjectTypeId,
                createdAt: this.booking.CreatedAt.toISOString(),
                isWebBooking: this.booking.IsWebRental,
                isOneWay: this.booking.IsOneWay,
                newRequest: true,
                addedProducts: this.booking.AddedProducts
            });

            if (ret == null || ret.IsEmpty) {
                this.UI.alert("Turbo.Core.RentalDialog.headInvalidDiscount", "Discount code not valid", "Turbo.Core.RentalDialog.errInvalidDiscount", "The discount code you have entered is not valid for this booking. Some parameters of the booking is outside the scope of the discount.");
            } else {
                this.booking.DiscountId = this.discount.code;
                this.isDiscountChanged = true;
                this.currentDiscount = ret;
                this.updatePrice();
            }
        } catch (ex) {
            this.UI.alert("Turbo.Core.RentalDialog.headInvalidDiscount", "Discount code not valid", "Turbo.Core.RentalDialog.errInvalidDiscount", "The discount code you have entered is not valid for this booking. Some parameters of the booking is outside the scope of the discount.");
        }
        this.localLoaders.discount = false;
    }

    public async createDiscount() {
        try {
            this.localLoaders.discount = true;

            if (this.discount.value < 0) {
                this.UI.alert("Turbo.Core.RentalDialog.headInvalidDiscountValue", "Invalid discount", "Turbo.Core.RentalDialog.errInvalidDiscountValue", "Value must be positive");
                return;
            }

            if (!this.discount.value || isNaN(this.discount.value)) {
                this.UI.alert("Turbo.Core.RentalDialog.headDiscountValueNaN", "Invalid discount", "Turbo.Core.RentalDialog.errDiscountValueNaN", "Value must be numeric");
                return;
            }

            if (this.discount.type == "%" && this.discount.value > 100) {
                this.UI.alert("Turbo.Core.RentalDialog.headInvalidDiscountPercentage", "Invalid discount", "Turbo.Core.RentalDialog.errInvalidDiscountPercentage", "Value must not be higher than 100%");
                return;
            }

            if (!this.discount.reason) {
                this.UI.alert("Turbo.Core.RentalDialog.headInvalidDiscountReason", "Invalid discount", "Turbo.Core.RentalDialog.errInvalidDiscountReason", "Reason must be specified.");
                return;
          }

            var ret = await this.Api.post<DiscountModel>("Price/CreateDiscount", null, {
                value: this.discount.value,
                type: this.discount.type == "%" ? DiscountValueType.Percentage : DiscountValueType.Monetary,
                reasonId: this.discount.reason,
                comment: this.discount.comment,
                pickupLocationId: this.booking.PickupLocationId,
                isOneWay: this.booking.IsOneWay
            });

            if (ret == null || ret.IsEmpty) {
                this.UI.alert("Turbo.Core.RentalDialog.headCreateDisountFailed", "Discount could not be created", "Turbo.Core.RentalDialog.errCreateDisountFailed", "The discount could not be created");
            } else {
                this.isDiscountChanged = true;
                this.booking.DiscountId = ret.DiscountId;
                this.currentDiscount = ret;
                this.updatePrice();
            }
        } catch (ex) {
            this.UI.alert("Turbo.Core.RentalDialog.headCreateDisountFailed", "Discount could not be created", "Turbo.Core.RentalDialog.errCreateDisountFailed", "The discount could not be created");
        } finally {
            this.localLoaders.discount = false;
        }
    }

    // </Validation>

    // <Events>
    public async selectedTabChange(e: MatTabChangeEvent) {
        
        if (e.tab == this.tabSecurityCheck) {
            var token = this.beginLoad("Turbo.Core.Dialogs.RentalDialog.ldrPhotos", "Preparing photos...", null);
            await this.getSecurityChecks();
            await this.getRentalPhotos();
            this.endLoad(token);
        }

        if (e.index == 1) this.loadObjectTab();
        if (e.index == 2) this.loadOtherTab();
    }
    // </Events>

    // <Commands>
    public sendSms() {
        this.Dialog.open(SmsDialog, { data: { rentalId: this.booking.Id, receiver: this.booking.Customer.Firstname, message: "" } });
    }

    public placeCall() {
        this.UI.confirm("Turbo.Core.BookingLink.ConfirmCall.Headline", "Are you sure?", "Turbo.Core.BookingLink.ConfirmCall.Message", "Place a call to {0}?", null, [this.booking.Customer.Firstname]).then(x => {
            if (x == true) {
                this.Dialog.open(CallDialog, { data: { rentalId: this.booking.Id, receiver: this.booking.Customer.Firstname } });
            }
        });
    }

    public confirm() {
        if (this.Settings.isInAny(['OneWayAdmin']) && this.booking.IsOneWay && this.booking.Status == 0) {
            this.UI.confirm("Turbo.Core.BookingLink.ConfirmConfirm.Headline", "Are you sure that you want to confirm this booking?", "Turbo.Core.BookingLink.ConfirmConfirm.Message", "Confirmations are normally carried out automatically. Make sure that all confirmed bookings will have a trailer. Continue?", null, null).then(y => {
                if (!y) return;

                this.Api.get<boolean>("Rental/Confirm", { booking: this.booking.Id }).then(x => {
                    if (x) {
                        this.booking.Status = RentalStatus.ReservedAndBound;
                        this.UI.alert("Turbo.Core.BookingLink.BookingConfirmed.Headline", "Success!", "Turbo.Core.BookingLink.BookingConfirmed.Message", "This booking has been confirmed.");
                    }
                });
            });
        }
    }

  public async resendConfirmation() {

    if (this.booking.Status == 0 || this.booking.Status == 50) {

      if (this.booking.IsOneWay && !this.Settings.isInAny(['OneWayAdmin'])) {
        this.UI.alert("Turbo.Core.BookingLink.resendEmailNotAdmin.Headline", "Failed!", "Turbo.Core.BookingLink.resendEmailNotAdmin.Message", "User is not an Admin.");
        return;
      }
      var x = await this.Api.get<boolean>("Rental/resendEmailConfirmation", { rentalID: this.booking.Id });
      if (x) {
        this.UI.alert("Turbo.Core.BookingLink.resendEmailConfirmed.Headline", "Success!", "Turbo.Core.BookingLink.resendEmailConfirmed.Message", "An email has been sent.");
      } else {
        this.UI.alert("Turbo.Core.BookingLink.resendEmailQueued.Headline", "Success!", "Turbo.Core.BookingLink.resendEmailQueued.Message", "An email has been queued.");
      }
    }
    else {
      this.UI.alert("Turbo.Core.BookingLink.resendEmailFailed.Headline", "Failed!", "Turbo.Core.BookingLink.resendEmailFailed.Message", "Emails can only be sent to preliminary or confirmed bookings.");
    }
  }

  public async flag() {
    if (this.Settings.isInAny(['OneWayAdmin']) && this.booking.IsOneWay && !this.booking.Flagged) {
      await this.Api.get<boolean>("Rental/Flag", { booking: this.booking.Id }).then(x => {
        if (x) {
          this.booking.Flagged = true;
        }
      });
    }
  }

    public async selectRentalObject(obj: RentalObjectInfo) {
        if (!obj.IsEnabled || !this.mayEdit) return;

        var x = await this.UI.confirm("Turbo.Core.RentalDialog.headConfirmObjectChange", "Change rental object?", "Turbo.Core.RentalDialog.msgConfirmObjectChange", 'Use "{0}" for this booking instead?', null, [obj.Title]);
        if (x) {
            this.booking.RentalObject = obj;
            this.booking.ObjectId = obj ? obj.Id : null;
            this.booking.PrimaryType = obj.Type;
            this.booking.PrimaryObjectTypeId = obj.Type.Id;

            this.selectedType = obj.Type;

            this.updateAddableProducts();
            this.validateBooking();
            this.isObjectChanged = true;
        }
    }

    public async selectObjectType(typeId: number) {
        var type = this.availableTypes.find(x => x.Id == typeId);
        var x = await this.UI.confirm("Turbo.Core.RentalDialog.headConfirmTypeChange", "Change object type?", "Turbo.Core.RentalDialog.msgConfirmTypeChange", 'Use "{0}" for this booking instead?', null, [type.Alias]);
        if (x) {
            this.booking.PrimaryType = type;
            this.booking.PrimaryObjectTypeId = type.Id;

            this.selectedType = type;

            this.updateAddableProducts();
            this.validateBooking();
            this.isObjectChanged = true;
        }
    }

    public async changePickupLocation() {
        var result = await this.Dialog.open(FindLocationDialog, { data: { Locations: this.locations, Role: 'Pickup', SelectedLocation: this.booking.PickupLocation } }).afterClosed().toPromise();
        if (result && this.booking.PickupLocationId != result.Id) {
                this.booking.PickupLocation = result;
                this.booking.PickupLocationId = this.booking.PickupLocation.Id;

            this.updateOpenHours();
            this.updateAddableProducts();
            this.validateBooking();
            this.updateState();

            this.isLocationChanged = true;
        }

        if (this.booking.IsOneWay && this.booking.PickupLocationId) this.availableTypes = await this.Api.get<ObjectTypeInfo[]>("/RentalObject/GetTypesAtLocation", { location: this.booking.PickupLocationId, oneway: true });
  }

  private isRebooking: boolean = false;
  private oldType: ObjectTypeInfo;
  private oldPickup: LocationInfo;
  public async rebook() {
    if (this.booking.Flagged || !this.booking.IsOneWay || this.booking.Status != RentalStatus.Reserved || !this.Settings.isInAny(["OneWayAdmin"])) return;

    var ret = await this.Dialog.open(NearbyOneWayAvailabilityDialog, { data: { locationId: this.booking.PickupLocation.Id, referenceTime: this.booking.PickupTime, selectedLocationId: this.booking.PickupLocation.Id, selectedTypeId: this.booking.PrimaryObjectTypeId, isWebBooking: this.booking.IsWebRental, showAllLocations: true } }).afterClosed().toPromise();
    if (ret) {
      this.oldType = this.booking.PrimaryType;
      this.oldPickup = this.booking.PickupLocation;

      if (this.booking.PickupLocationId != ret.locationId) {
        this.booking.PickupLocation = this.locations.find(x => x.Id == ret.locationId);
        this.booking.PickupLocationId = this.booking.PickupLocation.Id;

        await this.updateOpenHours();
        this.isLocationChanged = true;
      }

      if (this.booking.PrimaryObjectTypeId != ret.typeId) {
        this.booking.PrimaryType = this.availableTypes.find(x => x.Id == ret.typeId);
        this.booking.PrimaryObjectTypeId = this.booking.PrimaryType.Id;
        this.booking.RentalObject = null;
        this.booking.ObjectId = null;

        this.isObjectChanged = true;
      }

      await this.validateBooking();
      this.updatePrice();

      this.isRebooking = true;
    }
  }

    public async showNearby() {
      var ret = await this.Dialog.open(NearbyOneWayAvailabilityDialog, { data: { locationId: this.booking.PickupLocation.Id, referenceTime: this.booking.PickupTime, selectedLocationId: this.booking.PickupLocation.Id, selectedTypeId: this.booking.PrimaryObjectTypeId, isWebBooking: this.booking.IsWebRental } }).afterClosed().toPromise();
        if (ret) {
            if (this.booking.PickupLocationId != ret.locationId) {
                this.booking.PickupLocation = this.locations.find(x => x.Id == ret.locationId);
                this.booking.PickupLocationId = this.booking.PickupLocation.Id;

                this.updateOpenHours();
                this.isLocationChanged = true;
            }

            if (this.booking.PrimaryObjectTypeId != ret.typeId) {
                this.booking.PrimaryType = this.availableTypes.find(x => x.Id == ret.typeId);
                this.booking.PrimaryObjectTypeId = this.booking.PrimaryType.Id;
                this.booking.RentalObject = null;
                this.booking.ObjectId = null;

                this.isObjectChanged = true;
            }

            this.updateAddableProducts();
            this.validateBooking();
        }
    }

    public async changeReturnLocation() {
        var result = await this.Dialog.open(FindLocationDialog, { data: { Locations: this.locations, Role: 'Return', SelectedLocation: this.booking.ReturnLocation } }).afterClosed().toPromise();
        if (result && this.booking.ReturnLocationId != result.Id) {
            this.booking.ReturnLocation = result;
            this.booking.ReturnLocationId = this.booking.ReturnLocation.Id;

            this.updateOpenHours();
            this.updatePrice();
            this.validateBooking();
            this.updateState();

            this.isLocationChanged = true;
        }
    }

    public addonChanged(product: ObjectTypeInfo) {
        if (product.IsSelected) {
            this.addAddon(product);
        } else {
            this.removeAddon(product);
        }
    }

    private addAddon(product: ObjectTypeInfo) {
        if (this.booking.AddedProducts.indexOf(product.Id + ";") < 0) {
            this.booking.AddedProducts += product.Id + ";";
            this.booking.AddedProductIds.push(product.Id);
        }
        product.IsSelected = true;

        for (var i of this.availableAddons) {
            if (i.Id == product.Id || !i.IsSelected) continue;

          if (i.CheckCondition && eval(i.CheckCondition) !== true) {
                this.removeAddon(i);
            }
      }

      this.updatePrice();
      this.hasAddonsChanged = true;
    }

  private isFirstRun: boolean = true;
    private updateAddedProducts() {
        if (!this.booking.AddedProducts) this.booking.AddedProducts = "";
        if (!this.booking.AddedProductIds) this.booking.AddedProductIds = [];

  
       //Only getting run once, if we then deselect or select something else the default should not be re selected.
      if (!this.booking.Id && this.isFirstRun) {
        this.isFirstRun = false;
            for (var i of this.availableAddons) {
                if (i.IsDefault) {
                    this.addAddon(i);
                }
            }
        } else {
          var wasChanged = this.hasAddonsChanged;
            for (var t of this.booking.AddedProductIds) {
                var p = this.availableAddons.find(x => x.Id == t);
                if (p) this.addAddon(p);
                else {
                    if (this.booking.AddedProductIds.indexOf(t) >= 0) this.booking.AddedProductIds.splice(this.booking.AddedProductIds.indexOf(t));
                    this.booking.AddedProducts = this.booking.AddedProducts.replace(t + ";", "");

                    // Replacement?
                    var replacement = this.availableAddons.find(x => x.ReplacementFor && x.ReplacementFor.indexOf(t + ";") >= 0);
                    if (replacement) this.addAddon(replacement);
                }
          }
          this.hasAddonsChanged = wasChanged;
        }
    }

    private async queryAddons() {
        if (!this.booking.AddedProducts) this.booking.AddedProducts = "";
        if (!this.booking.AddedProductIds) this.booking.AddedProductIds = [];

        for (var i of this.availableAddons) {
            if (i.AskIfNotSelected && this.booking.AddedProducts.indexOf(i.Id.toString() + ";") < 0) {
                if (await this.UI.confirm("Turbo.Core.RentalDialog.headSuggestedAddon", "Suggested addon", "Turbo.Core.RentalDialog.msgSuggestedAddon", "Do you want to \"add{0}\" to this booking?", null, [i.Title])) {
                    this.addAddon(i);
              }
              break; // Only aske once
            }
        }
    }

  private removeAddon(product: ObjectTypeInfo) {
    product.IsSelected = false;

    this.booking.AddedProducts = this.booking.AddedProducts.replace(product.Id + ";", "");
    if (this.booking.AddedProductIds.indexOf(product.Id) >= 0) this.booking.AddedProductIds.splice(this.booking.AddedProductIds.indexOf(product.Id));

    this.updatePrice();
    this.hasAddonsChanged = true;
  }

  public async save(forceClose: boolean = false): Promise<Boolean> {
    //Booking metadata
    var metadata = new RentalMetaData();
    metadata.Source = "T4";

    // === Customer === ///
    var customer = new CustomerInfo();
    customer.Type = this.booking.Customer.Type;


    if (this.booking.Customer.Blocked) {
      var x = await this.UI.confirm("Turbo.Core.Dialogs.RentalDialog.headCustomerBlocked", "Customer is Blocked", "Turbo.Core.Dialogs.RentalDialog.msgCustomerBlocked", "Do you want to continue anyway?");
      if (!x) return; // Cancel;
      
    }

    // Validate
    if (!this.frmCustomerInfo.validate()) return false;
    console.log("Mask");

    // Set changed properties
    var customerChanged = false;

    if (this.frmCustomerInfo.dirty()) {
      customer = this.booking.Customer;
      customerChanged = true;
    }

    // Set id
    if (this.booking.Customer.Id && this.booking.Customer.Id != 0) { customer.Id = this.booking.Customer.Id; }

    // Save customer
    if (customerChanged) {;
      var cToken = this.beginLoad("Turbo.Core.Dialogs.RentalDialog.ldrSaveCustomer", "Updating customer info...", null);
      var y = await this.Api.post<CustomerInfo>("/Rental/SaveCustomer", customer, { isOneWay: this.booking.IsOneWay });

      if (y == null) {
        this.endLoad(cToken);
        return false;
      }

      if (this.booking.Customer.Id != y.Id) this.frmCustomerInfo.isCustomerChanged = true;
      this.booking.Customer = y;

      this.frmCustomerInfo.markFormPristine();

      this.endLoad(cToken);
    }
    if (!this.booking.Id) { // Add

      if (this.bookingValidation.AggregatedResult != BookingErrorCode.Valid) {
        //Check if booking is outside open hours for location and display a message to user
        if (!this.booking.IsOneWay && this.bookingValidation.AggregatedResult == BookingErrorCode.LocationNotOpen) {
          var x = await this.UI.confirm("Turbo.Core.RentalDialog.OpeningHoursError", "Are you sure?", "Turbo.Core.RentalDialog.msgConfirmOpeningHoursError", 'Are you sure that you want to save this booking outside of station opening hours?');
          if (!x) {
            return false;
          }
        }
        else {
          return false;
        }
      }

      var token = this.beginLoad("Turbo.Core.Dialogs.RentalDialog.ldrCreatingBooking", "Creating booking...", null);
      var result = await this.Api.post<BookingValidation>("/Rental/CreateBooking", null,
        {
          pickupTime: this.booking.PickupTime.toISOString(),
          returnTime: this.booking.ReturnTime.toISOString(),
          pickupLocation: this.booking.PickupLocationId,
          returnLocation: this.booking.ReturnLocationId,
          obj: this.booking.ObjectId,
          typeId: this.booking.PrimaryObjectTypeId,
          customer: this.booking.Customer.Id,
          discountId: this.booking.DiscountId,
          notes: this.booking.Note,
          isOneWay: this.booking.IsOneWay,
          rentalMetaData: JSON.stringify(metadata) 
        });

      


      if (result.AggregatedResult == BookingErrorCode.CustomerIsBlocked) {
        alert("Customer is blocked" + "\nReason: " + this.booking.Customer.BlockedReason);
        this.endLoad(token);
        return false;
      }

      if (result.AggregatedResult == BookingErrorCode.Valid || (!this.booking.IsOneWay && this.bookingValidation.AggregatedResult == BookingErrorCode.LocationNotOpen)) {
        this.booking.Id = result.BookingId;

        //this.booking = await this.Api.get<RentalInfo>("/Rental/GetRentalInfo", { bookingId: result.BookingId });

        this.pickupDate = this.booking.PickupTime.toDate();
        this.returnDate = this.booking.ReturnTime.toDate();
        this.receiptUri = this.sanitizer.bypassSecurityTrustResourceUrl(await this.rentalSvc.GetReceiptUri(this.booking.Id, "Pickup"));

        this.txtPickupDate.control.markAsPristine();
        this.txtPickupTime.markAsPristine();
        this.txtReturnDate.control.markAsPristine();
        this.txtReturnTime.markAsPristine();

        this.frmCustomerInfo.isCustomerChanged = false;
        this.isDiscountChanged = false;
        this.isLocationChanged = false;
        this.isObjectChanged = false;
        this.isPeriodChanged = false;

        this.Insights.logEvent("CreateBooking");
      } else {
        if (result.AggregatedResult == BookingErrorCode.LocationNotOpen) {
          var ret = await this.UI.alert("Turbo.Core.RentalDialog.BookingErrorCodeNotOpenHead", "Invalid booking!", "Turbo.Core.RentalDialog.BookingErrorCodeNotOpenMsg", "The location is not open for pickup at the specified pickup time.");
        }
        else if (result.AggregatedResult == BookingErrorCode.ObjectUnavailable) {
          var ret = await this.UI.alert("Turbo.Core.RentalDialog.BookingErrorCodeObjectUnavailable", "Trailer Unavailable", "Turbo.Core.RentalDialog.BookingErrorUnavailableMsg", "The trailer you are trying to book has just been reserved by another user.");
        }
        else if (result.AggregatedResult == BookingErrorCode.PeriodUnavailable) {
          var ret = await this.UI.alert("Turbo.Core.RentalDialog.BookingErrorInvalidPeriod", "Invalid booking period", "Turbo.Core.RentalDialog.BookingErrorInvalidPeriodMsg", "The start and/or end time you have selected is not valid. Please review and correct them and try again.");
        }
        else if (result.ErrorCode == 2048) {
          var ret = await this.UI.alert("Turbo.Core.RentalDialog.BookingErrorCodeCustomerIsBlocked2", "Account is blocked", "Turbo.Core.RentalDialog.BookingErrorCustomerIsBlockedMsg2", "Your customer number has been blocked for further rent. Please contact customer service.");
        }
        else if (result.ErrorCode == 4096) {
          var ret = await this.UI.alert("Turbo.Core.RentalDialog.BookingErrorCodeMaxBookingsPerDay2", "Maximum bookings per day reached", "Turbo.Core.RentalDialog.BookingErrorMaxBookingsPerDayMsg2", "You have reached the maximum number of bookings on one day. Welcome back tomorrow!");
        }
        else if (result.ErrorCode == 8192) {
          var ret = await this.UI.alert("Turbo.Core.RentalDialog.BookingErrorCodeMaximumConcurrentBookings2", "Maximum number of concurrent bookings reached", "Turbo.Core.RentalDialog.BookingErrorMaximumConcurrentBookingsMsg2", "You have reached the maximum number of concurrent bookings. Please return the active bookings and try again.");
        }
        else {
          var ret = await this.UI.alert("Turbo.Core.RentalDialog.BookingErrorCodeHead", "Something went wrong!", "Turbo.Core.RentalDialog.BookingErrorCodeMsg", "Please try again, or contact support if the problem persists. Errorcode: {0}", null, [result.AggregatedResult]);
        }
        this.endLoad(token);
        return false;
      }

      this.endLoad(token);
    } else { // Update

      var cancelClose = false;
      var token = this.beginLoad("Turbo.Core.Dialogs.RentalDialog.ldrUpdatingBooking", "Updating booking...", null);

      // Change booking parameters
      if (this.txtPickupDate.dirty || this.txtPickupTime.isDirty || this.txtReturnDate.dirty || this.txtReturnTime.isDirty || this.isObjectChanged || this.isLocationChanged || this.isPeriodChanged) {
        if (this.bookingValidation.AggregatedResult != BookingErrorCode.Valid) {
          //Check if booking is outside open hours for location and display a message to user
          if (this.booking.Status < RentalStatus.Active) {
            this.confirmedOutsideOpenHours = false;
            if (this.bookingValidation.PickupErrorCode == BookingErrorCode.LocationNotOpen || this.bookingValidation.ReturnErrorCode == BookingErrorCode.LocationNotOpen) {
              var x = await this.UI.confirm("Turbo.Core.RentalDialog.OpeningHoursError", "Are you sure?", "Turbo.Core.RentalDialog.msgConfirmOpeningHoursError", 'Are you sure that you want to save this booking outside of station opening hours?');
              if (!x) {
                return false;
              }
              else if (x) {
                this.confirmedOutsideOpenHours = true;
              }
            }
            else {
              return false;
            }
          }
        }

        var error = false;
        try {
          await this.Api.put<BookingValidation>("/Rental/UpdateBooking", null,
            {
              rentalId: this.booking.Id,
              pickupTime: this.booking.PickupTime.toISOString(),
              returnTime: this.booking.ReturnTime.toISOString(),
              pickupLocation: this.booking.PickupLocationId,
              returnLocation: this.booking.ReturnLocationId,
              obj: this.booking.ObjectId,
              typeId: this.booking.PrimaryObjectTypeId,
              allowOutsideOpenHours: this.confirmedOutsideOpenHours
            }
          )
            .then(y => {
              if (y.AggregatedResult == BookingErrorCode.Valid || y.AggregatedResult == BookingErrorCode.PickupReceiptUpdated || this.confirmedOutsideOpenHours) {
                if (y.AggregatedResult == BookingErrorCode.PickupReceiptUpdated) {
                  this.UI.alert("Turbo.Core.Dialogs.RentalDialog.headReceiptUpdated", "Pickup receipt has been updated", "Turbo.Core.Dialogs.RentalDialog.msgReceiptUpdated", "Correct the payment and reprint the receipt for the customer.");
                  this.tabReceipt.selectedIndex = 3;
                  cancelClose = true;
                }
                this.txtPickupDate.control.markAsPristine();
                this.txtPickupTime.markAsPristine();
                this.txtReturnDate.control.markAsPristine();
                this.txtReturnTime.markAsPristine();
                this.isObjectChanged = false;
                this.isLocationChanged = false;
                this.isPeriodChanged = false;
              } else {
                if (result.AggregatedResult == BookingErrorCode.LocationNotOpen) {
                  var ret = this.UI.alert("Turbo.Core.RentalDialog.BookingErrorCodeNotOpenHead", "Invalid booking!", "Turbo.Core.RentalDialog.BookingErrorCodeNotOpenMsg", "The location is not open for pickup at the specified pickup time.");
                }
                else if (result.AggregatedResult == BookingErrorCode.ObjectUnavailable) {
                  var ret = this.UI.alert("Turbo.Core.RentalDialog.BookingErrorCodeObjectUnavailable", "Trailer Unavailable", "Turbo.Core.RentalDialog.BookingErrorUnavailableMsg", "The trailer you are trying to book has just been reserved by another user.");
                }
                else if (result.AggregatedResult == BookingErrorCode.PeriodUnavailable) {
                  var ret = this.UI.alert("Turbo.Core.RentalDialog.BookingErrorInvalidPeriod", "Invalid booking period", "Turbo.Core.RentalDialog.BookingErrorInvalidPeriodMsg", "The start and/or end time you have selected is not valid. Please review and correct them and try again.");
                }
                else if (result.ErrorCode == 2048) {
                  var ret = this.UI.alert("Turbo.Core.RentalDialog.BookingErrorCodeCustomerIsBlocked2", "Account is blocked", "Turbo.Core.RentalDialog.BookingErrorCustomerIsBlockedMsg2", "Your customer number has been blocked for further rent. Please contact customer service.");
                }
                else if (result.ErrorCode == 4096) {
                  var ret = this.UI.alert("Turbo.Core.RentalDialog.BookingErrorCodeMaxBookingsPerDay2", "Maximum bookings per day reached", "Turbo.Core.RentalDialog.BookingErrorMaxBookingsPerDayMsg2", "You have reached the maximum number of bookings on one day. Welcome back tomorrow!");
                }
                else if (result.ErrorCode == 8192) {
                  var ret = this.UI.alert("Turbo.Core.RentalDialog.BookingErrorCodeMaximumConcurrentBookings2", "Maximum number of concurrent bookings reached", "Turbo.Core.RentalDialog.BookingErrorMaximumConcurrentBookingsMsg2", "You have reached the maximum number of concurrent bookings. Please return the active bookings and try again.");
                }
                else {
                  var ret = this.UI.alert("Turbo.Core.RentalDialog.BookingErrorCodeHead", "Something went wrong!", "Turbo.Core.RentalDialog.BookingErrorCodeMsg", "Please try again, or contact support if the problem persists. Errorcode: {0}", null, [result.AggregatedResult]);
                }
                error = true;
              }
            });
        } catch (x) {
          this.UI.alert("Turbo.Core.RentalDialog.errUpdatePeriodFailed", "Error when updating rental period", x.Key, x.Default, null, x.Data);
          error = true;
        }
      }

      // Change customer
      if (this.frmCustomerInfo.isCustomerChanged) {
        try {
          await this.Api.put<BookingValidation>("/Rental/SetCustomer", null,
            {
              rentalId: this.booking.Id,
              customer: this.booking.Customer.Id
            }
          )
            .then(y => {
              this.frmCustomerInfo.isCustomerChanged = false;
            });

        } catch (x) {
          this.UI.alert("Turbo.Core.RentalDialog.errUpdateCustomerFailed", "Error when updating rental customer", x.Key, x.Default, null, x.Data);
          error = true;
        }
      }

      // Change discount
      if (this.isDiscountChanged) {
        try {
          await this.Api.put<BookingValidation>("/Rental/SetDiscount", null, {
            rentalId: this.booking.Id,
            discountCode: this.booking.DiscountId
          }
          )
            .then(y => {
              this.isDiscountChanged = false;
            });
        } catch (x) {
          this.UI.alert("Turbo.Core.RentalDialog.errUpdateSettingsFailed", "Error when updating booking settings", x.Key, x.Default, null, x.Data);
          error = true;
        }
      }

      // Change notes
      if (this.txtNotes.dirty) {
        try {
          await this.Api.put<BookingValidation>("/Rental/SetNotes", null,
            {
              rentalId: this.booking.Id,
              notes: this.booking.Note
            }
          )
            .then(y => {
              this.txtNotes.control.markAsPristine();
            });
        } catch (x) {
          this.UI.alert("Turbo.Core.RentalDialog.errUpdateNotesFailed", "Error when updating rental notes", x.Key, x.Default, null, x.Data);
          error = true;
        }
      }


      this.endLoad(token);
      if (error) {
        return false;
      }
    }

    // Change international settings
    if (this.isForeignTravelChanged) {
      var token = this.beginLoad("Turbo.Core.Dialogs.RentalDialog.ldrSavingForeignTravel", "Saving foreign travel status...", null);
      try {
        await this.Api.put<BookingValidation>("/Rental/SetForeignTravel", null,
          {
            rentalId: this.booking.Id,
            code: this.booking.OutlandCode,
            country: this.booking.ForeignCountry,
          }
        );
        this.isForeignTravelChanged = false;
      } catch (x) {
        this.UI.alert("Turbo.Core.RentalDialog.errUpdateForeignFailed", "Error when updating rental international travel settings", x.Key, x.Default, null, x.Data);
        error = true;
      }
      this.endLoad(token);
    }

    // Change added products
    if (this.hasAddonsChanged) {
      var token = this.beginLoad("Turbo.Core.Dialogs.RentalDialog.ldrSavingForeignTravel", "Saving addons...", null);
      try {
        await this.Api.put<BookingValidation>("/Rental/SetAddons", null,
          {
            rentalId: this.booking.Id,
            products: this.booking.AddedProducts,
          }
        );
        this.hasAddonsChanged = false;
      } catch (x) {
        this.UI.alert("Turbo.Core.RentalDialog.errUpdateAddedFailed", "Error when updating added products", x.Key, x.Default, null, x.Data);
        error = true;
      }
      this.endLoad(token);
    }

    // Are we rebooking?
    if (this.isRebooking) {

      var oldCity = this.oldPickup.City;
      var oldSize = this.oldType.Title;

      var newStation = this.booking.PickupLocation.Name;
      var newSize = this.booking.PrimaryType.Title;

      var customerName = " " + this.booking.Customer.Firstname;
      if (customerName.indexOf("*") >= 0) customerName = ""; // Dont display customer name if masked
      if (this.booking.Customer.Firstname.indexOf(" ") >= 0) customerName = " " + this.booking.Customer.Firstname.substring(0, this.booking.Customer.Firstname.indexOf(" ")); // Dont display customer name if masked

      // Send message
      var message = "";
      if (this.oldPickup.Id != this.booking.PickupLocationId && this.oldType.Id != this.booking.PrimaryObjectTypeId) {
        // Both size and location changed
        message = `Hej${customerName}! Vi har dessvärre dåligt med ${oldSize} i området just nu. Jag bokar om dig till ett ${newSize} som står och väntar hos ${newStation} istället. Du får en bekräftelse inom kort. Oberservera att priset kan ha uppdaterats beroende på situationen på den nya stationen. Se bokningsbekräftelsen för mer information.`;
      } else if (this.oldPickup.Id != this.booking.PickupLocationId) {
        // Same size on different location
        message = `Hej${customerName}! Vi har dessvärre dåligt med ${oldSize} i ${oldCity} just nu. Jag bokar om dig till ${newStation} istället där det står ett släp och väntar. Du får en bekräftelse inom kortOberservera att priset kan ha uppdaterats beroende på situationen på den nya stationen. Se bokningsbekräftelsen för mer information..`;
      } else {
        // Different size on same location
        message = `Hej${customerName}! Vi har dessvärre dåligt med ${oldSize} i ${oldCity} just nu. Jag bokar om dig till ett ${newSize} istället. Du får en bekräftelse inom kort. Oberservera att priset kan ha uppdaterats för att matcha storleksbytet. Se bokningsbekräftelsen för mer information.`;
      }

      this.Api.post("Messaging/SendSms?rentalId=" + this.booking.Id + "&message=" + message, message);

      // Flag
      await this.flag();

      // Confirm
      await this.Api.get<boolean>("Rental/Confirm", { booking: this.booking.Id }).then(x => {
        if (x) {
          this.booking.Status = RentalStatus.ReservedAndBound;
        }
      });
    }

    this.endLoad(token);

    if (forceClose && !cancelClose) this.dialogRef.close(this.booking);
    return true;
  }

  public async closeRentalDialog() {
    if (this.damageCostAdded && this.booking.Status == RentalStatus.Returned) {
      var ret = await this.UI.confirm("Turbo.Service.CreateServiceRequestDialog.DamageHeadline", "You have reported damage in relation to this booking. Do you want to create a damage report?", "Turbo.Service.CreateServiceRequestDialog.DamageReportQuestion", "You have reported damage in relation to this booking. Do you want to create a damage report?");
      if (ret) {
        await CreateServiceRequestDialog.open(this.Dialog, this.booking.ObjectId, this.booking.ReturnLocationId, this.booking.RentalObject, this.booking.Id);
      }
    }
    this.dialogRef.close(this.booking);
  }
    public async predisclose() {
        return await this.disclose(undefined, true);
    }

    public async openSMSDialog() {
        var retrying = false;
        var code = await this.Dialog.open(SmsCodeDialog, { data: { retry: retrying } }).afterClosed().toPromise();
    }


  public async cancelCost(row) {
    var message = await this.UI.prompt("Turbo.Core.RentalDialog.headCommnet", "Comment", "Turbo.Core.RentalDialog.msgAddComment", " ");

    if (message != null) {
      message = "Cost canceled: " + message;

      if (await this.Api.post<number>("Price/CancelCost", null, { costId: row.Id, description: message }))
        this.tblCosts.update();
    }
  }

  public async cancelPaymentRequest(row) {

    var message = await this.UI.prompt("Turbo.Core.RentalDialog.headCommnet", "Comment", "Turbo.Core.RentalDialog.msgAddComment", " ");

    if (message != null) {
      //PBI 815: Add cancel payment prefix for comments as "Payment request canceled: "
      message = "Payment request canceled: " + message;

      await this.Api.post<CustomerInfo>("RentalService/RentalEvent", null, { rentalId: this.booking.Id, type: 0, message: message });

      if (await this.Api.post<boolean>("/Rental/CancelPaymentRequest", null, { requestId: row.Id })) {
        this.tblPaymentRequests.update();
        this.tblPayments.update();
        this.tblCosts.update();
      }
    }
  }

  public async invoiceManually(row) {
    var message = await this.UI.prompt("Turbo.Core.RentalDialog.ManuallyRequest2", "Set status to manually Invoiced", "Turbo.Core.RentalDialog.msgAddCommentAnnata", "Add invoice number from Annata");

    if (message != null) {
      //PBI 815: Add  prefix for comments as "PL manually invoiced: "
      message = row.RentalId + " Annata: " + message;
            
      if (await this.Api.get<PaymentRequestInfo>("RentalService/RegisterManualInvoice", { requestId: row.Id, invoiceRef: message })) {
        this.tblPaymentRequests.update();
        this.tblPayments.update();
        this.tblCosts.update();
      }
    }
  }

    public async disclose(bypassPayment: boolean = false, predisclose: boolean = false) {
        await this.queryAddons();

      if (!await this.save()) return;

      // Inform user about oneway status
      if (this.booking.IsOneWay) {
        if (this.booking.RentalObject.IsSelfServiceEnabled) {
          
        } else {

        }
      }


        if (this.Settings.clientSettings.Bookings.UseDigitalSignature) {
            this.Api.get<boolean>("/Rental/BeginDigitalSigning", { rental: this.booking.Id });

            var retrying: boolean = false;
            var isValid: Boolean = false;
            do {
                var code = await this.Dialog.open(SmsCodeDialog, { data: { retry: retrying } }).afterClosed().toPromise();
                if (!code) {
                    if (this.Settings.clientSettings.Bookings.RequireDigitalSignature) return; // Cancel

                    var x = await this.UI.confirm("Turbo.Core.Dialogs.RentalDialog.headSkipSigning", "Bypass digital signing?", "Turbo.Core.Dialogs.RentalDialog.msgSkipSigning", "Do you want to continue without a digital signature?");
                    if (x) {
                        isValid = true;
                    } else {
                        return; // Cancel;
                    }
                }
                else if (code == "NoCode") {
                    var x = await this.UI.confirm("Turbo.Core.Dialogs.RentalDialog.headSkipSigning", "Bypass digital signing?", "Turbo.Core.Dialogs.RentalDialog.msgSkipSigning", "Do you want to continue without a digital signature?");

                    if (x) {
                        isValid = true;
                    }
                }
                else {
                    isValid = await this.Api.get<boolean>("/Rental/ValidateSignature", { rental: this.booking.Id, token: code });
                }
            } while (!isValid);
        }

        var token = this.beginLoad("Turbo.Core.Dialogs.RentalDialog.ldrStartingRental", "Starting rental...", null);
      var result = await this.Api.post<PickupResultCode>("/Rental/Disclose", null,
            {
                rentalId: this.booking.Id,
                bypassCardPayment: bypassPayment,
                predisclose: predisclose

        });


      if (result == PickupResultCode.NotWithinTimeLimit)
      {
          await this.UI.alert("Turbo.Core.Dialogs.RentalDialog.msgNotWithinTimeLimit", "To early to start this booking. Change the pickup time to continue.", null, null);
          this.endLoad(token);
          return PickupResultCode.NotWithinTimeLimit;
      }

      if (result == PickupResultCode.PaymentFailed) {
          if (await this.UI.confirm("Turbo.Core.Dialogs.RentalDialog.errPaymentHeadline", "Payment failed!", "Turbo.Core.Dialogs.RentalDialog.errPaymentMessage", "Credit card payment failed for this rental. Do you want to try again?")) {
              this.endLoad(token);
              return await this.disclose();
          } else {
              await this.UI.alert("Turbo.Core.Dialogs.RentalDialog.msgBypassPaymentHeadline", "Bypassing payment!", "Turbo.Core.Dialogs.RentalDialog.msgBypassPaymentMessage", "You have choosen to bypass credit card payment. Remeber to charge the customer manually!")
              this.endLoad(token);
              return await this.disclose(true);
          }
      } else if (result == PickupResultCode.SuccessWithPayment) {
        await this.UI.alert("Turbo.Core.Dialogs.RentalDialog.msgPaymentSuccessHeadline", "Credit card payment succeeded!", "Turbo.Core.Dialogs.RentalDialog.msgPaymentSuccessMessage", "The cost for this rental has successfully been charged to the customers credit card. Do NOT charge the customer in store!");
      } else if (result == PickupResultCode.SuccessWithoutPayment && this.booking.IsOneWay) {
          await this.UI.alert("Turbo.Core.Dialogs.RentalDialog.msgNoPaymentHeadline", "No credit card payment was made", "Turbo.Core.Dialogs.RentalDialog.msgNoPaymentMessage", "No automatic credit card payment was made for this rental. Please verify that payment is already registered. If not, make sure to take payment in the store!");
      } 

        this.booking.ActivatedAt = moment();
        this.booking.Status = RentalStatus.Active;
        this.endLoad(token);

        token = this.beginLoad("Turbo.Core.Dialogs.RentalDialog.msgBookingStarted", "Rental started successfully!", null);
        await new Promise(resolve => setTimeout(resolve, 200));

        this.tabReceipt.selectedIndex = 3;
        this.endLoad(token);

      this.Insights.logEvent("ActivateBooking");

      // show warning for high trailers
      var highTrailers = [26, 36, 64, 90, 304, 305, 307, 308, 310, 425, 431, 436, 437, 440, 459, 467, 480, 526, 530, 554, 568, 569, 570, 578, 625, 626, 653, 660, 680, 716, 842];
      if (highTrailers.indexOf(this.booking.PrimaryObjectTypeId) >= 0) {
        this.UI.openDialog("T4.Bookings.TrailerHeightWarningDialog", { maxWidth: "400px" });
      }

        //this.dialogRef.close(this.booking);

        this.updateState();
    }

    public async cancel() {
        var x = await this.UI.confirm("Turbo.Core.RentalDialog.headConfirmCancel", "Are you safe?", "Turbo.Core.RentalDialog.msgConfirmCancel", 'Are you secure that you want to cancel this booking?');
        if (x) {
            var token = this.beginLoad("Turbo.Core.Dialogs.RentalDialog.ldrCancellingRental", "Cancelling booking...", null);
            var result = await this.Api.delete<BookingErrorCode>("/Rental/Cancel",
                {
                    booking: this.booking.Id
                });

            if (result == BookingErrorCode.Valid) {
                this.booking.Status = RentalStatus.Canceled;
                this.endLoad(token);

                var token = this.beginLoad("Turbo.Core.Dialogs.RentalDialog.msgBookingCanceled", "The booking is canceled!", null);
                await new Promise(resolve => setTimeout(resolve, 200));
                this.endLoad(token);

                this.Insights.logEvent("CancelBooking");

                this.closeRentalDialog();
            } else {
                alert("Failed! " + result);
            }
        }

        this.updateState();
  }

  public async reverse() {

    var newstatus = -1;

    var x = await this.UI.confirm("Turbo.Core.RentalDialog.headConfirmActvate", "Are you sure?", "Turbo.Core.RentalDialog.msgConfirmReverse", 'Are you secure that you want to reverse booking?');
    if (x) {
      var token = this.beginLoad("Turbo.Core.Dialogs.RentalDialog.ldrReversingRental", "Reversing booking...", null);
      await this.Api.get<boolean>("/Rental/ReversBooking", { bookingId: this.booking.Id }); // RentalId bookingId
      this.endLoad(token);

      this.LoadBooking(this.booking.Id);
    }
  }

    public async return() {
        if (!await this.save()) return;

        //var result = await ReturnDialog.returnBooking(this.Dialog, this.booking);
        var dlg = this.Dialog.open(ReturnDialog, {
            maxHeight: "calc(100vh - 20px)",
            maxWidth: "calc(100vw - 20px)",
            width: "800px",
            data: {
                booking: this.booking
            }
        });

      var result = await dlg.afterClosed().toPromise();

      //If we have added a cost when returning the booking, we will set it to true.
      //In turn we will show to "Create Damage report" when the rental Dialog is closed.
      if (result?.damageCostAdded)
        this.damageCostAdded = result?.damageCostAdded;
    

        if (result?.extraReceiptExists === false) this.dialogRef.close(this.booking.Id);
        else if (result?.extraReceiptExists === true) {
            var token = this.beginLoad("Turbo.Core.Dialogs.RentalDialog.ldrRental", "Preparing booking...", null);
            this.booking = await this.Api.get<RentalInfo>("/Rental/GetRentalInfo", { bookingId: this.params.booking });

            this.pickupDate = this.booking.PickupTime.toDate();
            this.returnDate = this.booking.ReturnTime.toDate();
            this.selectedType = this.booking.PrimaryType;

            this.receiptUri = this.sanitizer.bypassSecurityTrustResourceUrl(await this.rentalSvc.GetReceiptUri(this.booking.Id, "Pickup"));
            this.extraReceiptUri = this.sanitizer.bypassSecurityTrustResourceUrl(await this.rentalSvc.GetReceiptUri(this.booking.Id, "Return"));

            this.tblCosts.update();
            this.extraReceiptExists = true;
            this.updateOpenHours();
            this.updateAddableProducts();
            this.validateBooking();
            this.updatePricingIntervals();            
            this.tabReceipt.selectedIndex = 4;
            this.endLoad(token);
        }


        //this.returnTime = moment();
        //this.isReturnState = true;
        //this.checkBookingForReturn();
    }
    public confirmAdditionalPayment() { this.returnValidation.Action = ReturnResultAction.Confirm; }
    public rejectAdditionalPayment() { this.returnValidation.Action = ReturnResultAction.Ignore; }
    public async reportDamages() {
        var x: SparepartPriceModel[] = await CreateServiceRequestDialog.open(this.Dialog, this.booking.ObjectId, this.booking.ReturnLocationId, this.booking.RentalObject, this.booking.Id);

        if (x) {
            var addons = [];
            var totalPrice = 0;
            var definition = "";
            for (var i = 0; i < x.length; i++) {
                addons.push(x[i].SparepartId);

                totalPrice += x[i].Price;
                definition += ", " + await this.Translate.translate("Turbo.Core.Dialogs.RentalDialog.SparePart." + x[i].SparepartId);
            };
            if (definition.length > 0) definition = definition.substring(2);

            var addExtra = await this.UI.confirm("Turbo.Core.Dialogs.RentalDialog.confirmExtraCostHeadline", "Confirm damage cost", "Turbo.Core.Dialogs.RentalDialog.confirmExtraCostText", "You have reported damage in relation to this booking and there is an extra cost associated. Do you want to add {0} to the receipt?", null, [totalPrice]);

            if (addExtra) {
                this.returnValidation.ReceiptExists = true;
                if (this.returnValidation.Action != ReturnResultAction.Ignore) this.returnValidation.Action = ReturnResultAction.Confirm;

                this.processReturn(addons, definition);
                return;
            }

            // Process without damage
            this.processReturn();
        }
    }
    public async processReturn(addons: number[] = [], extraReason: string = "") {
        token = this.beginLoad("Turbo.Core.Dialogs.RentalDialog.msgReturning", "Returning booking...", null);

      var result = await this.Api.post<ReturnResultCode>("/Rental/Return", null,
        {
            rentalId: this.booking.Id,
            returnTime: this.returnTime.toISOString(),
            returnLocation: this.booking.ReturnLocationId,
            receiptAction: (this.returnValidation) ? this.returnValidation.Action : ReturnResultAction.Unspecified,
            bypassCardPayment: false,
            addons: addons,
            extraReason: extraReason
        });

        // Validations
      if (result == ReturnResultCode.LockOpen) {
            await this.UI.alert("Turbo.Core.Dialogs.RentalDialog.errReturnFailed", "Return failed!", "Turbo.Core.Dialogs.RentalDialog.errLockIsOpen", "The lock on this trailer is not closed. Please close the lock and try again.")
            return;
        }

      if (result == ReturnResultCode.NotAtLocation) {
            await this.UI.alert("Turbo.Core.Dialogs.RentalDialog.errReturnFailed", "Return failed!", "Turbo.Core.Dialogs.RentalDialog.errNotAtLocation", "The Trailer is not at the correct location. Please drive it back to the return location and try again.")
            return;
        }

      if (result == ReturnResultCode.PaymentActionRequired) {
            await this.UI.alert("Turbo.Core.Dialogs.RentalDialog.errReturnFailed", "Return failed!", "Turbo.Core.Dialogs.RentalDialog.errLockIsOpen", "Payment action is required")
            this.checkBookingForReturn();
            return;
        }

      while (result == ReturnResultCode.PaymentFailed) {
            var response = await this.UI.confirm("Turbo.Core.Dialogs.RentalDialog.errPaymentFailed", "Card payment failed!", "Turbo.Core.Dialogs.RentalDialog.errPaymentFailedText", "The credit card could not be charged. Do you want to try again?")
            if (response) {
                this.endLoad(token);
                this.processReturn();
                return;
            } else {
                await this.UI.alert("Turbo.Core.Dialogs.RentalDialog.errManualPayment", "Important note!", "Turbo.Core.Dialogs.RentalDialog.errLockIsOpen", "Turbo has not been able to charge the customer. Remember to collect payment from the customer manually! ")
              result = await this.Api.post<ReturnResultCode>("/Rental/Return", null,
                    {
                        rentalId: this.booking.Id,
                        returnTime: this.returnTime.toISOString(),
                        receiptAction: (this.returnValidation) ? this.returnValidation.Action : ReturnResultAction.Unspecified,
                        bypassCardPayment: true,
                        addons: addons,
                        extraReason: extraReason
                    });
            }
        }

      if (result != ReturnResultCode.Success) {
            await this.UI.alert("Turbo.Core.Dialogs.RentalDialog.errReturnFailed", "Return failed!", "Turbo.Core.Dialogs.RentalDialog.errUnknown", "Unknown error")
            return;
        }

        this.Insights.logEvent("ActivateBooking");
        this.booking.Status = RentalStatus.Returned;
        this.booking.ReturnedAt = this.returnTime;
        this.booking.ExtraReceiptExists = this.returnValidation.ReceiptExists;
        this.booking.ExtraReceiptSkipped = this.returnValidation.Action == ReturnResultAction.Ignore;

        this.endLoad(token);

        var token = this.beginLoad("Turbo.Core.Dialogs.RentalDialog.msgReturned", "Booking has been returned", null);
        await new Promise(resolve => setTimeout(resolve, 200));

        if (this.booking.ExtraReceiptExists) {
            this.tabReceipt.selectedIndex = 4;
            this.isReturnState = false;
        } else {
            //this.dialogRef.close(this.booking);
        }
        this.endLoad(token);

        this.updateState();
    }

    // </Commands>

    // <Helpers>
  public async updatePricingIntervals() {
      if (this.booking.PickupLocationId)
        this.pricingIntervals = await this.Api.get<number[]>("/Price/GetPricingIntervals", { locationId: this.booking.PickupLocationId, pickupTime: this.booking.PickupTime.toISOString(), typeId: this.booking.PrimaryObjectTypeId });
   }

    public async updateOpenHours() {
        if (!this.booking.IsOneWay) {
            var ret = await this.Api.get<OpenHours[]>("/Location/GetOpenHoursForPeriod", { locationId: this.booking.PickupLocationId, startDate: this.booking.PickupTime.toISOString(), endDate: this.booking.ReturnTime.toISOString() });

            var pickup = ret.find(x => x.Date.clone().startOf("day").isSame(this.booking.PickupTime.clone().startOf('day')));
            var returnT = ret.find(x => x.Date.clone().startOf("day").isSame(this.booking.ReturnTime.clone().startOf('day')));

            // Pickup
            if (pickup) {
                this.pickupOpens = moment(pickup.Opens.clone().utc().format("YYYY-MM-DD HH:mm:ss"));
                this.pickupCloses = moment(pickup.Closes.clone().utc().format("YYYY-MM-DD HH:mm:ss"));
            }

            // Return
            if (returnT) {
                this.returnOpens = moment(returnT.Opens.clone().utc().format("YYYY-MM-DD HH:mm:ss"));
                this.returnCloses = moment(returnT.Closes.clone().utc().format("YYYY-MM-DD HH:mm:ss"));
            }
        } else if (this.booking.PickupLocationId) {

          // Pickup
          if (this.booking.PickupLocationId) {

            var pickupRet = await this.Api.get<OpenHours[]>("/Location/GetOpenHoursForPeriod", { locationId: this.booking.PickupLocationId, startDate: this.booking.PickupTime.toISOString(), endDate: this.booking.ReturnTime.toISOString() });

            var pickup = pickupRet.find(x => x.Date.clone().startOf("day").isSame(this.booking.PickupTime.clone().startOf('day')));

            if (pickup) {
              this.pickupOpens = moment(pickup.Opens.clone().utc().format("YYYY-MM-DD HH:mm:ss"));
              this.pickupCloses = moment(pickup.Closes.clone().utc().format("YYYY-MM-DD HH:mm:ss"));
            }
          }

          // Return
          if (this.booking.ReturnLocationId) {

            var returnRet = await this.Api.get<OpenHours[]>("/Location/GetOpenHoursForPeriod", { locationId: this.booking.ReturnLocationId, startDate: this.booking.PickupTime.toISOString(), endDate: this.booking.ReturnTime.toISOString() });

            var returnT = returnRet.find(x => x.Date.clone().startOf("day").isSame(this.booking.ReturnTime.clone().startOf('day')));

            if (returnT) {
              this.returnOpens = moment(returnT.Opens.clone().utc().format("YYYY-MM-DD HH:mm:ss"));
              this.returnCloses = moment(returnT.Closes.clone().utc().format("YYYY-MM-DD HH:mm:ss"));
            }
          } 
        }
    }

    public updatePrice() {
        if (!this.booking || !this.booking.PickupLocationId || !this.booking.ReturnLocationId) return;

        this.localLoaders.price = true;
        this.Api.get<PriceModel>("/Price/GetRentalPrice",
            {
                pickupTime: this.booking.PickupTime.toISOString(),
                returnTime: this.booking.ReturnTime.toISOString(),
                objectTypeId: this.booking.PrimaryObjectTypeId,
                pickupLocationId: this.booking.PickupLocationId,
                returnLocationId: this.booking.ReturnLocationId,
                useInsurance: false,
                webBooking: this.booking.IsWebRental,
                actualReturnTime: this.booking.ReturnedAt ? this.booking.ReturnedAt.toISOString() : (this.booking.Status == RentalStatus.Late ? moment().toDate().toISOString() : this.booking.ReturnTime.toISOString()),
                createdAt: this.booking.CreatedAt.toISOString(),
                discountId: this.booking.DiscountId,
                addedProducts: this.booking.AddedProducts,
                bookingLng: this.booking.BookingLng,
                bookingLat: this.booking.BookingLat,
                isOneWay: this.booking.IsOneWay

            }).then(y => {
                this.currentPrice = y;
                this.localLoaders.price = false;
        });
    }

    public async updateAddableProducts() {
        if (!this.booking) return;

      this.localLoaders.addableTypes = true;
      this.availableAddons = await this.Api.get<ObjectTypeInfo[]>("/RentalObject/GetAddons", { typeId: this.booking.PrimaryObjectTypeId, locationId: this.booking.PickupLocationId });
        this.updateAddedProducts();

        this.localLoaders.addableTypes = false;
    }

    public async checkBookingForReturn() {
        if (!this.booking) return;

        this.localLoaders.return = true;
        this.returnValidation = await this.Api.post<ReturnValidation>("/Rental/ValidateForReturn", null,
            {
                rentalId: this.booking.Id,
                returnTime: this.returnTime.toISOString(),
                pickupLocation: this.booking.PickupLocationId,
                returnLocation: this.booking.ReturnLocationId
            });

        this.localLoaders.return = false;
    }

  public async refund(payment: PaymentInfo) {
    await this.UI.openDialog("T4.Bookings.RefundDialog", { data: { payment: payment, rentalId: this.booking.Id } });
    this.tblPayments.update();
    this.tblCosts.update();
  }

  public async addCost() {
    var ret = await this.UI.openDialog("T4.Bookings.AddCostDialog", { data: { rentalId: this.booking.Id } });
    this.tblCosts.update();
  }

  public async requestPayment() {
    var ret = await this.UI.openDialog<PaymentRequestInfo>("T4.Bookings.RequestPaymentDialog", { data: { rentalId: this.booking.Id, email: this.booking.Customer.Email, amount: this.unsettledAmount(), firstname: this.booking.Customer.Firstname } });
    this.tblPaymentRequests.update();
  }

  public unsettledAmount() {

    var sum = 0;
    if (this.tblCosts) 
      this.tblCosts.data.filteredData.filter(x => !x.IsCanceled && !x.PaymentId).map(x => sum += x.Amount)

    return sum;
  }

  public activePaymentRequests(): boolean {
    if(this.tblPaymentRequests)
      return this.tblPaymentRequests?.data.filteredData.some(x => x.Status < 100 && !x.PaymentId);
     
    return false;
  }

  public getReceiptUri(paymentRef: string) {
    var ret: SafeResourceUrl = "https://api.turbo4.net/Documents/Receipt/DownloadPaymentReceipt?rentalId=" + this.booking.Id + "&paymentRef=" + paymentRef;

    return ret;
  }

  private runningValidateBooking: boolean = false;
    public async validateBooking() {
      if (!this.booking || !this.booking.PickupLocationId || !this.booking.ReturnLocationId) return;
      if (this.runningValidateBooking) return;

      this.runningValidateBooking = true;
      await delay(1000);
      this.runningValidateBooking = false;

        this.localLoaders.period = true;
        this.bookingValidation = await this.Api.post<BookingValidation>("/Rental/ValidateBooking", null,
            {
                rentalId: this.booking.Id,
                pickupTime: this.booking.PickupTime.toISOString(),
                returnTime: this.booking.ReturnTime.toISOString(),
                pickupLocation: this.booking.PickupLocationId,
                returnLocation: this.booking.ReturnLocationId,
                isOneWay: this.booking.IsOneWay,
                objectId: this.booking.ObjectId
            });

        this.localLoaders.period = false;
    }

    private loadLocations(): Promise<any> {
        return this.Api.get<LocationInfo[]>("/Location/GetAvailableLocations", { isOneway: this.booking.IsOneWay }).then(x => {
            for (var i of x.sort((a, b) => {
                if (a.Latitude > b.Latitude) return -1;
                if (a.Latitude < b.Latitude) return 1;
                if (a.Name < b.Name) return -1;
                return 1;
            })) {
                this.locations.push(i);
            }
        });
    }

    public async loadObjectTab() {
        if (this.loadStatus.objects) return;
        this.loadStatus.objects = true;

        this.loading.dialog = true;

        // Load data for object tab
        var objects: RentalObjectInfo[];
        if (this.Settings.clientSettings.RentalLocationId)
            objects = await this.Api.get<RentalObjectInfo[]>("/RentalObject/GetObjects", { location: this.Settings.clientSettings.RentalLocationId, oneway: this.booking.IsOneWay });
        else if (this.booking.PickupLocationId)
            objects = await this.Api.get<RentalObjectInfo[]>("/RentalObject/GetObjects", { location: this.booking.PickupLocationId, oneway: this.booking.IsOneWay });
        else if (this.Settings.clientSettings.IsOneWay) {
            //Choose location first
            this.tabReceipt.selectedIndex = 0;
            this.UI.alert("Turbo.Core.RentalDialog.headPickupLocationNotSelected", "No pickup location", "Turbo.Core.RentalDialog.msgPickupLocationNotSelected", "Please choose a pickup location to see available trailers.");
            this.loading.dialog = false;
            return;
        }
        var categoryKeys = {};

        for (var i of objects.sort((a, b) => {
            if (a.CategoryIndex < b.CategoryIndex) return -1;
            if (a.CategoryIndex > b.CategoryIndex) return 1;
            if (a.IsEnabled < b.IsEnabled) return 1;
            if (a.IsEnabled > b.IsEnabled) return -1;
            if (a.Status < b.Status) return -1;
            if (a.Status > b.Status) return 1;
            if (a.Alias < b.Alias) return -1;
            if (a.Alias > b.Alias) return 1;

            return 0;
        })) {
            var category = "Other";
            if (i.Category) category = i.Category;

            if (!categoryKeys[category]) categoryKeys[category] = category.indexOf("Turbo.Data") == 0 ? this.translate(category) : category;


            if (i.IsEnabled) { // Do not display disabled objects
                var cat = categoryKeys[category];
                if (!this.availableObjects[cat]) {
                    this.availableCategories.push(cat);
                    this.availableObjects[cat] = [];
                }

                this.availableObjects[cat].push(i);
            }
        }

        this.loading.dialog = false;
        this.loadStatus.objects = false;
    }

    public async loadOtherTab() {
        this.loading.dialog = true;

        this.discountReasons = await this.Api.get<DiscountReasonInfo[]>("Rental/GetDiscountReasons", { isOneWay: this.booking.IsOneWay});

        if (this.booking.DiscountId != null && this.booking.DiscountId != '')
            this.currentDiscount = await this.Api.get<DiscountModel>("Price/GetDiscount", { code: this.booking.DiscountId });

        this.localLoaders.discount = false;

        this.countries = await this.Api.get<Country[]>("Settings/GetCountries", {});
        this.filteredCountries = this.countries.sort((a, b) => a.Name < b.Name ? -1 : 1)

        if (this.booking.ForeignCountry)
            this.selectCountry(this.countries.find(x => x.Code == this.booking.ForeignCountry));

        this.loading.dialog = false;
    }

    private round(date: moment.Moment, precision: number, key: string): moment.Moment {
        var direction = 'round';

        var keys = ['Hours', 'Minutes', 'Seconds', 'Milliseconds'];
        var maxValues = [24, 60, 60, 1000];

        // Capitalize first letter
        key = key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();

        // make sure key is plural
        if (key.indexOf('s', key.length - 1) === -1) {
            key += 's';
        }
        var value = 0;
        var rounded = false;
        var subRatio = 1;
        var maxValue;
        for (var i in keys) {
            var k = keys[i];
            if (k === key) {
                value = date.toDate()['get' + key]();
                maxValue = maxValues[i];
                rounded = true;
            } else if (rounded) {
                subRatio *= maxValues[i];
                value += date.toDate()['get' + k]() / subRatio;
                date.toDate()['set' + k](0);
            }
        };

        value = Math[direction](value / precision) * precision;
        value = Math.min(value, maxValue);
        var ret = moment(date.toDate()['set' + key](value));

        ret = ret.seconds(0);
        ret = ret.milliseconds(0);

        return ret;
  }

  public async AddComment() {
    var message = await this.UI.prompt("Turbo.Core.RentalDialog.headCommnet", "Comment", "Turbo.Core.RentalDialog.msgAddComment", " ");
    await this.Api.post<CustomerInfo>("RentalService/RentalEvent", null,{ rentalId: this.booking.Id, type: 507, message: message });  
  }
    // </Helpers>

    public static async openBooking(dialog: MatDialog, bookingId: number, tabIndex: number = 0): Promise<RentalInfo> {
        var dlg = dialog.open(RentalDialog, {
            maxHeight: "calc(100vh - 20px)",
            maxWidth: "calc(100vw - 20px)",
            width: "1200px",
            data: {
                booking: bookingId,
                tabIndex: tabIndex
            }
        });

        return await dlg.afterClosed().toPromise();
    }
    public static async newBooking(dialog: MatDialog, data: any, settings: SettingsService): Promise<RentalInfo> {

        if (data.pickupTime && data.returnTime) {
            if (moment(data.returnTime).diff(moment(data.pickupTime), 'minute') < 60)
                data.returnTime = new Date(data.pickupTime + settings.clientSettings.Bookings.DefaultBookingLength * 60 * 60 * 1000);
        }
        
        var dlg = dialog.open(RentalDialog, {
            maxHeight: "calc(100vh - 20px)",
            maxWidth: "calc(100vw - 20px)",
            width: "1200px",
            data: data
        });

        return await dlg.afterClosed().toPromise();
    }
 

  private customerFieldChanges: any[] = [];
  private processingCustomerChanges: boolean = false;
  async customerValueChanged(field: any) {
    if (!field.isValid) return;

    this.customerFieldChanges.push(field);
    if (this.customerFieldChanges.length > 0)
      await this.processCustomerFieldChanges();
  }

  private async processCustomerFieldChanges() {
    if (this.processingCustomerChanges) return;
    this.processingCustomerChanges = true;

    while (this.customerFieldChanges.length > 0) {
      var field = this.customerFieldChanges.splice(0, 1)[0];
      if (field.fieldId === "Id") await this.validateSSN(field.value);
      if (field.fieldId === "Personnummer") await this.lookupCustomer(field.value);
    }

    this.processingCustomerChanges = false;
  }

  public async validateSSN(value: string): Promise<boolean> {
    this.frmCustomerInfo.isLoading = true;
    var customer = await this.Api.get<CustomerInfo>("/Rental/FindCustomer", { customerIdentification: value, type: this.booking.Customer.Type, isOneWay: this.booking.IsOneWay });  
    if (customer) {
      if (this.booking.Customer.Id != customer.Id) {
        this.frmCustomerInfo.isCustomerChanged = true;
      }

      this.booking.Customer = customer;

      if (this.booking.Customer.Id) {
        this.frmCustomerInfo.markFormPristine();
      }
      else {
        this.frmCustomerInfo.markFormDirty();
      }
    }
    else {
      this.booking.Customer.Id = null;
      this.frmCustomerInfo.isCustomerChanged = true;
    }

    this.frmCustomerInfo.isLoading = false;
    return true;
  }

  public async lookupCustomer(value: string) {
    if (this.booking.Customer?.Id) {
      return;
    }

    this.frmCustomerInfo.isLoading = true;
    var customer = await this.Api.get<CustomerInfo>("/Customer/LookupCustomer", { ssn: value, type: this.booking.Customer.Type });
    if (customer) {
  
      // Keep person info if company and not existing
      for (var p in customer.Fields) {
        if (p != "Id" && p != "MobilePhone" && p != "Personnummer" && customer.Fields[p])
          this.booking.Customer.Fields[p] = customer.Fields[p];
      }

      if (!customer.Id && customer.Type == CustomerType.Company) {
        if (!customer.Fields["Firstname"]) customer.Firstname = this.booking.Customer.Firstname;
        if (!customer.Lastname) customer.Lastname = this.booking.Customer.Lastname;
        if (!customer.Email) customer.Email = this.booking.Customer.Email;
        if (!customer.MobilePhone) customer.MobilePhone = this.booking.Customer.MobilePhone;

      }

      //this.booking.Customer = customer;
      this.frmCustomerInfo.markFormDirty();
      this.frmCustomerInfo.update();
    }

    this.frmCustomerInfo.isLoading = false;
  }


  public async openCustomerDialog() {

    var ret = await CustomerDialog.open(this.Dialog, this.booking.Customer, this.booking.Customer.Id);

    if (ret) {
      this.booking.Customer = await this.Api.get<CustomerInfo>("/Rental/GetCustomerInfo", { customerId: this.booking.Customer.Id });
    }
    
  }

 async ngOnChanges(changes: SimpleChanges) {

    if (changes.bookingInput)
    {
      var token = this.beginLoad("Turbo.Core.Dialogs.RentalDialog.ldrRental", "Preparing booking...", null);
      this.mayEdit = false;

      /*if (this.tabReceipt != undefined) this.tabReceipt.selectedIndex = 0;*/

      await this.LoadBooking(this.bookingInput);

      await this.getSecurityChecks();
      await this.getRentalPhotos();

      this.endLoad(token);

      const lastIndex = this.tabReceipt._allTabs.length;
      this.tabReceipt.selectedIndex = lastIndex - 1;

      setTimeout(() => {
      }, 50);
 
    }
  }

  public async restartFromNow() {
    var token = this.beginLoad("Turbo.Core.Dialogs.RentalDialog.ldrRestartingRentalFromNow", "Restarting booking from now...", null);

    var reason = await this.UI.prompt("Turbo.Core.RentalDialog.MoveBooking", "Move booking to now", "Turbo.Core.RentalDialog.msgMoveBooking", " ");
    var result = await this.Api.get<number>("/Rental/MoveBookingTime", { rentalId: this.booking.Id, reason });

    if (result == 0) {
      this.UI.alert("Turbo.Core.SetTranslation.ErrorMsgTitle", "Failed!", "Turbo.Core.SetTranslation.ErrorMsgNoReplaceTrailers", "Can't start the booking now because there is no replacement trailers");
    }

    this.endLoad(token);
  }

  public async regenerateReceipt() {
    this.localLoaders.receipt = true;
    var result = await this.Api.get<boolean>("/Rental/CreateReceipt", { rentalId: this.booking.Id, type: ReceiptType.Receipt });
    this.localLoaders.receipt = false;
    if (result && this.receiptUri) {
      const url = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this.receiptUri);
      if (url) {
        window.open(url, '_blank');
      }
    }
  }
}
